/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner
 */
export interface CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner {
    /**
     * 
     * @type {Date}
     * @memberof CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner
     */
    endTime: Date;
}

/**
 * Check if a given object implements the CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner interface.
 */
export function instanceOfCalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner(value: object): value is CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner {
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerFromJSON(json: any): CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner {
    return CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerFromJSONTyped(json, false);
}

export function CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
    };
}

  export function CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerToJSON(json: any): CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner {
      return CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerToJSONTyped(json, false);
  }

  export function CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInnerToJSONTyped(value?: CalculateWorkingTimeCostDataUnpaidWorkingPeriodsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
    };
}

